import InputMask from "react-input-mask";
import { noop } from "../../../../lib";
import React, { forwardRef } from "react";
import clsx from "clsx";
import { InputProps } from "./index";

export const PhoneInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      name,
      onChange,
      type,
      value = "",
      disabled = false,
      onFocus = noop,
      onBlur = noop,
      children,
      wrapClassName,
      className,
      label,
      id,
      isValid = true,
      error,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={clsx(
          "flex flex-col items-start text-white w-full relative",
          wrapClassName
        )}
      >
        {children}
        <InputMask
          className={clsx(
            "h-[38px] w-full border text-body font-medium rounded-[6px] px-3 py-2 border-white-gray text-gray-light focus:outline-none focus:border-primary-base disabled:bg-white disabled:text-alarm-not-accepted",
            {
              "border-input-error focus:border-input-error": Boolean(error),
            },
            className
          )}
          placeholder={label}
          mask="+380 99 999 9999"
          value={value}
          onChange={onChange}
        />

        {/*{label && (*/}
        {/*  <label*/}
        {/*    className="absolute left-0 -top-3.5 text-light-gray text-[12px] leading-[18px] transition-all peer-placeholder-shown:text-[14px] peer-placeholder-shown:leading-[21px] peer-placeholder-shown:top-1.5 peer-focus:-top-3.5 peer-focus:text-[12px] peer-focus:leading-[18px]"*/}
        {/*    htmlFor={id || name}*/}
        {/*  >*/}
        {/*    {label}*/}
        {/*  </label>*/}
        {/*)}*/}
      </div>
    );
  }
);
